// src/components/ParticipantInstructions.jsx

import React from 'react';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import itiniri_logo_light from '../../images/itiniri_logo_light.png';

/**
 * Generates a one‑page PDF with step‑by‑step instructions for event participants/vendors.
 *
 * Props:
 *  - gatheringReferenceID: string — the “GRID” code to embed in the PDF
 */
const ParticipantInstructions = ({ gatheringReferenceID }) => {
  // The four instruction steps
  const steps = [
    {
      title: '1) Create an account',
      description: 'Go to itiniri.app and sign up for an account.',
    },
    {
      title: '2) Create your Artist/Vendor profile',
      description:
        'Paste the GRID (Gathering Reference ID) into the “Event Code” field during profile creation.',
    },
    {
      title: '3) Upload & customize your profile',
      description:
        'Add your profile image, bio, website links, etc., in the dashboard.',
    },
    {
      title: '4) (Artists only) Claim your event',
      description:
        'Click “View Schedule,” then hit “Claim” next to your event so your name, photo and links appear in the app.',
    },
  ];

  const generatePdf = () => {
    const doc = new jsPDF({ unit: 'pt', format: 'letter' });

    // — add centered logo at top —
    const pageWidth = doc.internal.pageSize.getWidth();
    const imgProps = doc.getImageProperties(itiniri_logo_light);
    const imgWidth = 120;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
    const imgX = (pageWidth - imgWidth) / 2;
    doc.addImage(itiniri_logo_light, 'PNG', imgX, 30, imgWidth, imgHeight);

    // — title —
    doc.setFontSize(18);
    doc.text(
      'Participant / Vendor Onboarding',
      pageWidth / 2,
      imgHeight + 70,
      { align: 'center' }
    );

    // — GRID code line —
    doc.setFontSize(12);
    doc.text(
      `Your Event Code (GRID): ${gatheringReferenceID}`,
      40,
      imgHeight + 100
    );

    // — build table of steps via the autotable plugin —
    autoTable(doc, {
      startY: imgHeight + 120,
      head: [['Step', 'Instruction']],
      body: steps.map((s) => [s.title, s.description]),
      theme: 'grid',
      styles: { fontSize: 11, cellPadding: 6 },
      headStyles: { fillColor: [22, 160, 133] },
      columnStyles: {
        0: { cellWidth: 100 },
        1: { cellWidth: pageWidth - 160 },
      },
    });

    // — save file —
    doc.save(`Instructions_${gatheringReferenceID}.pdf`);
  };

  return (
    <button onClick={generatePdf} style={{ width: "50%", marginBottom: "10px" }}>
      Download Instructions PDF
    </button>
  );
};

export default ParticipantInstructions;
